var map = {
	"./logo_1.png": "d096",
	"./logo_10.png": "9ced",
	"./logo_11.png": "2cde",
	"./logo_2.png": "6bc4",
	"./logo_3.png": "2e06",
	"./logo_4.png": "6fea",
	"./logo_5.png": "1a0c",
	"./logo_6.png": "68a5",
	"./logo_7.png": "cfa8",
	"./logo_8.png": "12e3",
	"./logo_9.png": "fc97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "771c";